import React from 'react';
import { Redirect } from 'react-router-dom';

class PaginaError extends React.Component{
    render(){
        return(
            <Redirect to="/administrador/login"/>
        );
    }
}

export default PaginaError;